import React, { useState } from 'react';
import { useAlert } from '../../contexts/alerta';
import { FaCloudUploadAlt } from 'react-icons/fa';

export default function InputFile({ name, change, label }) {
  const [isError, setIsError] = useState(false)

  const anexo = {
    nomeArquivo: '',
    arquivo : '',
    dataEnvio : new Date().getTime()
  }

  const { addAlert } = useAlert()

  const getBase64 = file => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    anexo.nomeArquivo = file.name;
    reader.onload = () => {
      anexo.arquivo = reader.result 
      change(anexo);
    };
  };

  const onChange = e => {
    setIsError(false)
    const file = e.target.files[0];
    if (file)
      if (file.size > 5000000) {
        addAlert('O tamanho do arquivo excedeu o limite: 5MB', 'error')
        document.getElementById(name).value = ''
        setIsError(true)
      } else
        getBase64(file);
  };
  return (
    <div className='flex flex-col gap-2'>
        <label className='p-2 flex hover:cursor-pointer uppercase items-center gap-2 border-2 text-primary font-semibold border-primary rounded w-64 justify-center hover:bg-primary hover:text-white' htmlFor={name}>
          <FaCloudUploadAlt />{label}
          <input
            id={name}
            className='hidden'
            type="file" 
            name={name}
            onChange={onChange} />
        </label>
      {
        isError && <span className='text-sm font-thin text-warning'>Imagem maior que o tamanho permitido</span>
      }
    </div>
  )
};
